import React, { useState } from 'react';

const API = 'http://localhost:8000/api/v1';

function NPS() {
  const [score, setScore] = useState(null);
  const [message, setMessage] = useState('');

  const submit = async (s) => {
    setScore(s);
    const res = await fetch(API + '/feedback/nps?score=' + s, { method: 'POST' });
    const data = await res.json();
    setMessage(data.message);
  };

  return (
    <div>
      <h2>Rate Khepri</h2>
      <p style={{ color: '#94A3B8', marginTop: 8, marginBottom: 16 }}>How likely are you to recommend us? (1–10)</p>
      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(n => (
          <button
            key={n}
            onClick={() => submit(n)}
            style={{
              width: 36,
              height: 36,
              borderRadius: '50%',
              border: score === n ? '2px solid #6366F1' : '1px solid #334155',
              background: score === n ? '#6366F1' : '#1E293B',
              color: '#F8FAFC',
              cursor: 'pointer',
              fontWeight: 600,
            }}
          >
            {n}
          </button>
        ))}
      </div>
      {message && (
        <div style={{ marginTop: 16, padding: 14, background: '#10B981', color: '#fff', borderRadius: 8, textAlign: 'center' }}>
          {message}
        </div>
      )}
    </div>
  );
}

export default NPS;